import { message, type Payloads } from "utilities/message";
import { err, ok } from "utilities/result";
import type { VerificationSubmitValues } from "../types/Verification";

type ReopenAccountPayload = Payloads["reopen-account"];

const reopen = async (payload: ReopenAccountPayload) => {
  const [response, error] = await message("reopen-account", payload);

  if (error) {
    return err(error);
  }

  return ok(response);
};

const submitVerification = async (payload: VerificationSubmitValues) => {
  const [response, error] = await message(
    "submit-verification-data-update",
    payload,
  );

  if (error) {
    return err(error);
  }

  return ok(response);
};

export const accountService = {
  reopen,
  submitVerification,
};
